import { render, staticRenderFns } from "./bulkdelete.vue?vue&type=template&id=bb1e4bf8&"
import script from "./bulkdelete.vue?vue&type=script&lang=js&"
export * from "./bulkdelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports